import { Container, Content } from "./styles";
import { api } from "../../services/api";
import Header from "../../components/Header/Header";
import { validEmail } from "../utils/regex";

import GoogleLogin, {
  GoogleLoginResponse,
  GoogleLoginResponseOffline,
} from "react-google-login";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

type ParamsProps = {
  id: string;
};

export function LoginGoogle() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [emailGoogle, setEmailGoogle] = useState("");
  const { id } = useParams<ParamsProps>();
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  const [ip, setIP] = useState(0);
  const [location, setLocation] = useState(false);

  const validate = () => {
    if(!validEmail.test(email)){
      toast.error("Insira um e-mail válido!");
    }else{
      SendData()
    };
  }

  function SendData() {
    if (location === true) {
      api.post("/recievepolicies", {
        uuid: id,
        ip: ip,
        latitude: lat,
        longitude: lng,
        email: email,
      });
      history.push("/success");
    } else {
      api.post("/recievepolicies", {
        uuid: id,
        ip: null,
        latitude: null,
        longitude: null,
        email: email,
      });
      history.push("/success");
    }
  }

  const SendDataGoogle = useCallback(() => {
  if (location === true) {
    api.post("/recievepolicies", {
      uuid: id,
      ip: ip,
      latitude: lat,
      longitude: lng,
      email: emailGoogle,
    });
    history.push("/success");
  } else {
    api.post("/recievepolicies", {
      uuid: id,
      ip: null,
      latitude: null,
      longitude: null,
      email: emailGoogle,
    });
    history.push("/success");
  }
}, [location, id, ip, lat, lng, emailGoogle, history]);

  const Getdata = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIP(res.data.IPv4);
    setLat(res.data.latitude);
    setLng(res.data.longitude);
  };

  useEffect(() => {
    Getdata();
    navigator.geolocation.getCurrentPosition((position) => {
      setLocation(true);
    });
  }, []);

  useEffect(() => {
  if (emailGoogle !== "") SendDataGoogle();
}, [emailGoogle, SendDataGoogle]);

  const responseGoogle = async (
    response: GoogleLoginResponse | GoogleLoginResponseOffline
  ) => {
    const resp = response as GoogleLoginResponse;
    const {
      profileObj: { email },
    } = resp;
    setEmailGoogle(email);
  };

  return (
    <Container>
      <Toaster position="bottom-left" />
      <Header />
      <Content>
        <h2>Faça seu cadastro</h2>
        <div>
          <p>Para continuar, entre com sua conta Google:</p>
        </div>
        <div>
          <GoogleLogin
            clientId="256855571523-eu9n45ru1glefir3v6666o464klk0e84.apps.googleusercontent.com"
            buttonText="Continuar com o Google"
            onSuccess={responseGoogle}
          />
        </div>
        <div>
          <p>Ou</p>
        </div>
        <div>
          <p>Digite um e-mail válido:</p>
        </div>
        <div className="email">
          <input
            className="form"
            // //ts-ignore
            type="email"
            name="email"
            placeholder="Digite seu e-mail"
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={validate}>Enviar</button>
        </div>
       </Content>
    </Container>
  );
}
